import styled from "styled-components";
import { colors, font, radius } from "../../styles/theme/tokens";

export const WeekSelectorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;
  font-family: ${font.text};

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
`;

export const WeekTitle = styled.h3`
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: ${colors.muted};
`;

export const WeeksContainer = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const WeekButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-height: 44px;
  padding: 6px 16px;
  border: 1px solid ${(props) => (props.active ? colors.brand : colors.line)};
  border-radius: ${radius.md};
  font-family: ${font.text};
  font-size: 14px;
  font-weight: 700;
  color: ${(props) => (props.active ? "#FFFFFF" : colors.ink)};
  background: ${(props) => (props.active ? colors.brand : colors.surface)};
  box-shadow: ${(props) => (props.active ? `0 6px 16px ${colors.brand}55` : "none")};
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;

  small {
    font-size: 11px;
    font-weight: 700;
    color: ${(props) => (props.active ? "rgba(255,255,255,0.85)" : colors.muted)};
  }

  &:hover {
    border-color: ${colors.brand};
  }

  &:focus-visible {
    outline: 2px solid ${colors.brandDeep};
    outline-offset: 2px;
  }
`;
